module.exports = __webpack_public_path__ + "static/Nueng.27edded7.png";